/**
 * Stempelt den Bestand eines Projekts nach einer Gruppen-Zuordnung nach
 * (`PROJECT_DOC_GROUP_STAMPER`, siehe `app-providers.ts`).
 *
 * Alle Teile laufen durch, auch wenn einer scheitert — danach wird geworfen,
 * mit Namen und Grund je gescheitertem Teil. Bis 30.09.2026 stand hier ein
 * blankes `Promise.allSettled`: Scheiterte etwa das Nachstempeln der Punkte,
 * sah der Nutzer „erledigt", und die Punkte blieben ungestempelt, fuer die Gruppe
 * unsichtbar. Den Fehler meldet die Bibliothek (`zuordneGruppe`) ans
 * Error-Tracking und dem Nutzer; die Zuordnung selbst bleibt stehen.
 */
export type BestandsTeil = (projectId: string, groups: string[], vorher?: string[]) => Promise<unknown>;

export async function stempleProjektBestand(
	teile: Record<string, BestandsTeil>,
	projectId: string,
	groups: string[],
	vorher?: string[],
): Promise<void> {
	const namen = Object.keys(teile);
	const ergebnisse = await Promise.allSettled(namen.map(name => teile[name](projectId, groups, vorher)));
	const gescheitert = ergebnisse
		.map((e, i) => e.status === 'rejected'
			? `${namen[i]}: ${e.reason instanceof Error ? e.reason.message : String(e.reason)}`
			: null)
		.filter((z): z is string => !!z);
	if (gescheitert.length > 0) throw new Error(gescheitert.join('; '));
}
